import React, { FC } from 'react';

import { useTranslation } from 'Modules/core/i18n';
import { Stack, Typography } from 'Modules/ui3';
import { ModalComponentProps } from 'Modules/core/messaging';

import modalStyles from '../ui/index.module.scss';


const PersonalDataComponent: FC = () => {
    const { t } = useTranslation('personaleData');
    return (
        <Stack p={8} pr={7} maxWidth='560px' maxHeight='100%'>
            <Typography variant='boldTitle5' color='grayscale.shade95'>
                {t('title')}
            </Typography>
            <Typography
                component='p'
                className={modalStyles.scrollable}
                mt={4}
                variant='regularCaption1'
                color='grayscale.shade85'
            >
                {t('content')}
            </Typography>
        </Stack>
    );
};

export const PersonalDataModal: ModalComponentProps = {
    component: PersonalDataComponent,
    containerClass: modalStyles.container,
    modalClass: modalStyles.modal,
    closeButtonVariant: 'dfaSmall',
};
